
@if (!loading){
  <div class="module-bar-fixed">
    <button mat-icon-button (mousedown)="appService.goBack()">
      <mat-icon svgIcon="arrow_next" class="rotate-ltr"></mat-icon>
    </button>
    <span class="title text-truncate">
      <div>{{ 'OAT.create_tab_title' | translate }}</div>
      @if (tableNum) {
        <small style="position:relative;" [innerHTML]="'OAT.table_no_alt' | translate: {v: tableNum} | safeHtml"></small>
      }
    </span>
  </div>

  <div class="module-body-fixed">

    <div class="px-3 text-center" [class.pt-3]="tableNum">

      <!--<div class="text-lg mb-3">
      {{ 'OAT.create_tab_details_info' | translate }}
    </div>-->

    <div class="h-info-steps mb-4">
      @for (step of infoSteps; track step; let last = $last) {
        <div class="h-info-step">
          <div class="icon"><mat-icon [svgIcon]="step.icon" ></mat-icon></div>
          <div class="title">{{step.c | translate}}</div>
        </div>
        @if (!last) {
          <div class="_separator">
            <mat-icon svgIcon="chevron_next" class="rotate-rtl"></mat-icon>
          </div>
        }
      }
    </div>
  </div>


  <div class="mx-3 mb-3">
    <div class="my-panel-info">
      <div class="d-flex" style="gap:16px; font-size: 13px">
        <mat-icon svgIcon="paper_plane" class="text-accent" style="min-width: 24px"></mat-icon>
        <div>
          <div class="fw-bold mb-1">{{ 'OAT.share_tab_splash_title' | translate }}</div>
          <div>{{ 'OAT.share_tab_splash_info' | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="my-panel mb-base no-shadow text-base condensed-fields">
    <div class="my-panel-body pb-0">
      <p></p>
      <form #f="ngForm" [formGroup]="contactForm" class="condensed-fields">

        <mat-form-field color="accent" appearance="outline">
          <mat-label>{{'OAT.field_tab_name' | translate}}</mat-label>
          <input name="tabName" matInput formControlName="tabName" required maxlength="30">
          @if (tabName?.hasError('maxlength')) {
            <mat-error>{{'VALIDATIONS.MAXLENGTH' | translate: {val:30} }}</mat-error>
          }
        </mat-form-field>

        @if (!tableId && !tableNum) {
          <mat-form-field appearance="outline">
            <mat-label>{{'OAT.table_number' | translate}}</mat-label>
            <input #orderno name="tableNumber" matInput formControlName="tableNumber" required inputmode="numeric" pattern="[0-9]*" maxlength="4">
          </mat-form-field>
        }

        @if (tpAccount?.supportPreAuthAmount) {
          <mat-form-field appearance="outline">
            <mat-label>{{'OAT.field_amount_limit' | translate}}</mat-label>
            <input name="amountLimit" matInput formControlName="amountLimit" required type="number" inputmode="numeric" />
            <span matTextSuffix>$</span>

            <mat-hint><i class="text-xs">{{ 'OAT.fixed_charge_amount_title' | translate }}</i></mat-hint>
            @if (amountLimit?.hasError('min') || amountLimit?.hasError('max')) {
              <mat-error>{{amountText}}</mat-error>
            }
          </mat-form-field>
        }
      </form>
    </div>
  </div>

  @if (tpAccount) {
    <div class="mx-3 mb-3">
      <div class="my-panel-info px-1 border">
        <div class="d-flex" style="gap:16px; font-size: 13px">
          <mat-checkbox class="example-margin" [(ngModel)]="contactForm.reviewItemsBeforeSending">
            <div>
              <div class="fw-bold mb-1">{{ 'OAT.review_before_sending_title' | translate }}</div>
              <div>{{ 'OAT.review_before_sending_info' | translate }}</div>
            </div>
          </mat-checkbox>
        </div>
      </div>
    </div>
  }

  @if (amountLimit?.value) {
    <div class="grecaptcha-text d-flex animated faster fadeInUp mb-base">
      <mat-icon class="me-2" svgIcon="info_circle" style="min-width: 16px"></mat-icon>
      <div style="text-align: start;">
        <div>{{ 'OAT.charge_disclaimer' | translate:{v: amountLimit.value | lcurrency} }}</div>
        @if ($storage.site?.tableOrdering?.defaultTip) {
          <div class="mt-2">{{ 'OAT.default_charge_tip' | translate:{val: $storage.site?.tableOrdering?.defaultTip} }}</div>
        }
      </div>
    </div>
  }
</div>


<div class="p-3 fixed-bottom">
  <button mat-raised-button color="accent" class="lg rounded btn-block" type="button" (click)="createSharedOrder()">
    {{'continue' | translate}}
  </button>
</div>
}

<!--<app-power-by-tabit></app-power-by-tabit>-->
